import { Injectable } from '@angular/core';
import { ConfigManagerService } from '@xpo-ltl/config-manager';
import { ConfigManagerProperties } from '../enums/config-manager-properties.enum';

@Injectable({
  providedIn: 'root',
})
export class ApplicationUtilsService {
  constructor(public configManagerService: ConfigManagerService) {}

  buildVersion: string = this.configManagerService.getSetting<string>(ConfigManagerProperties.buildVersion);
  readonly helpLink =
    'https://xpologistics.sharepoint.com/:f:/r/sites/150/ttdd/Pricing-RFP/Deliverables/Pricing%20Analyst%20Curriculum/7.%20Artemis?csf=1&web=1&e=B1hdzZ';
  readonly releaseNotesLink =
    'https://xpologistics.sharepoint.com/:f:/r/sites/150/ttdd/Pricing-RFP/Deliverables/Pricing%20Analyst%20Curriculum/7.%20Artemis/Artemis%20Release%20Notes?csf=1&web=1&e=aOgVjI';
}
